import { shallowEqual, useDispatch, useSelector } from 'react-redux'

import type { Role } from '@app/domain/iam/user.interface'
import type { AppState } from '@app/state'

import { actions, queries } from './state'

import type { State } from './state';

export function useAuth() {
  const dispatch = useDispatch()
  const authState = useSelector<AppState, State>(
    (state) => state.auth,
    shallowEqual,
  )

  return {
    ...authState,
    beginOauth() {
      dispatch(actions.oauth())
    },
    submitCredentials(username: string, password: string) {
      dispatch(actions.credentials(username, password))
    },
    hasRole(role: Role) {
      return queries.hasRole(authState, role)
    },
    isAuthenticated: queries.isAuthenticated(authState),
    isPending: queries.isPending(authState),
  }
}
